<button [ngClass]="getButtonClasses()" (click)="onClick()" type="{{ role }}" [ngStyle]="{'height': customHeight, 'width': customWidth}" [disabled]="isLoading || disabled">
    <div class="content-wrapper">
        <div class="text-content">
            <ng-content></ng-content>
        </div>
        <div class="loader" *ngIf="isLoading">
            <img id="loading-anim" src="../../../../../assets/loadinganim.gif">
        </div>
    </div>
</button>